export default class  ResourceViewModel {
    id: number;
    work_orders_id: number;
    additional_type: string;
    reason: string;
    status: string;
    issued_by_users_id: number;
    deleted_at: string | null;
    created_at: string;
    updated_at: string;
    workorder: any;
    materials: {
        id: number;
        work_order_additional_resources_id: number;
        material_id: number;
        proposed_qty: number;
        remaining_qty: number;
        deleted_at: string | null;
        created_at: string;
        updated_at: string;
        material: {
            id: number;
            sparepart_no: string;
            item_name: string;
            speisifikasi: string;
        };
    }[];
    manpowers: {
        id: number;
        work_order_additional_resources_id: number;
        qty: number;
        scope_of_work: string | null;
        deleted_at: string | null;
        created_at: string;
        updated_at: string;
    }[];
    verificator: any;

    constructor(data: any = {}) {
        this.id = data.id || 0;
        this.work_orders_id = data.work_orders_id || 0;
        this.additional_type = data.additional_type || "";
        this.reason = data.reason || "";
        this.status = data.status || "";
        this.issued_by_users_id = data.issued_by_users_id || 0;
        this.deleted_at = data.deleted_at || null;
        this.created_at = data.created_at || "";
        this.updated_at = data.updated_at || "";
        this.materials = data.materials || [];
        this.manpowers = data.manpowers || [];
    }
}
